import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null); const [hidden, setHidden] = useState(() => localStorage.getItem("velocity_install_dismissed") === "1");
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    window.addEventListener("appinstalled", () => setEvt(null));
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (!evt || hidden || window.matchMedia("(display-mode: standalone)").matches) return null;
  const install = async () => { evt.prompt(); await evt.userChoice; setEvt(null); };
  const dismiss = () => { localStorage.setItem("velocity_install_dismissed", "1"); setHidden(true); };
  return (
    <div className="fixed bottom-24 left-4 right-4 sm:left-auto sm:right-5 sm:w-[340px] z-40 rounded-2xl border border-cyan-400/30 bg-[#131722]/95 backdrop-blur p-4 shadow-xl shadow-cyan-500/10 flex items-start gap-3 rise" data-testid="install-prompt">
      <img src="/icons/icon-192.png" alt="" className="w-11 h-11 rounded-xl" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Install MY VELOCITY</p>
        <p className="text-xs text-slate-400 mt-0.5">One tap from your home screen — load board, check-ins and alerts, full screen.</p>
        <button onClick={install} className="mt-2 inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-cyan-400 text-slate-950 text-xs font-semibold" data-testid="install-prompt-install"><Download className="w-3.5 h-3.5" />Install app</button>
      </div>
      <button onClick={dismiss} aria-label="Dismiss" className="text-slate-500 hover:text-white" data-testid="install-prompt-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
